<template>
  <v-container fluid class="py-0 my-0 mt-0">
    <v-row class="py-0 my-0">
      <v-col md="9" sm="6" cols="12" class="py-0 my-0">
        <p
          class="google-font mb-1"
          style="font-size:150%"
        ><b>Rechtliche Fragen und Auskünfte</b></p><p
          class="google-font mb-1"
          style="font-size:110%"
        >
Wenn Sie der Meinung sind, dass Inhalte, die sich auf HolyCode befinden oder zugänglich sind, ein Urheberrecht verletzt, informieren Sie uns bitte über untenstehende E-Mail Adresse. Entsprechende Inhalte werden wir umgehend entfernen, kennzeichnen oder verbessern.
</p>
        <p class="google-font">{{data.shortDescription}}</p>
        <p class="google-font mt-5">Bitte kontaktieren Sie <a style="color:#1565C0;text-decoration: none;" :href="`mailto:kontakt@holy-code.de `">kontakt@holy-code.de</a></p>
        <span v-for="(item,i) in data.hashtags" :key="i" >
          <v-chip
            class="mr-1 mb-1"
            :href="'https://twitter.com/hashtag/'+item"
            target="_blank"
            label
          >#{{item}}</v-chip>
        </span>
      </v-col>
      <!--
      <v-col md="3" sm="6" cols="12" class="py-0 my-0">
        <img :src="require('@/assets/img/svg/contact.svg')" style="float:right" width="80%" alt />
      </v-col>
      -->
    </v-row>
    <hr><br>
    <p>English Version</p>
    <v-row class="py-0 my-0">
      <v-col md="9" sm="6" cols="12" class="py-0 my-0">
        <p
          class="google-font mb-1"
          style="font-size:150%"
        ><b>Legal questions and requests for user information</b></p><p
          class="google-font mb-1"
          style="font-size:110%"
        >
If you believe that content residing or accessible on HolyCode infringes a copyright, please send a notice of copyright infringement to the E-Mail Adress below. We will remove, mark or improve the corresponding content immediately.
</p>
        <p class="google-font">{{data.shortDescription}}</p>
        <p class="google-font mt-5">Please contact <a style="color:#1565C0;text-decoration: none;" :href="`mailto:kontakt@holy-code.de `">kontakt@holy-code.de</a></p>
        <span v-for="(item,i) in data.hashtags" :key="i" >
          <v-chip
            class="mr-1 mb-1"
            :href="'https://twitter.com/hashtag/'+item"
            target="_blank"
            label
          >#{{item}}</v-chip>
        </span>
      </v-col><!--
      <v-col md="3" sm="6" cols="12" class="py-0 my-0">
        <img :src="require('@/assets/img/svg/contact.svg')" style="float:right" width="80%" alt />
      </v-col>
      -->
    </v-row>
    <hr><br>
    <v-row class="py-0 my-0">
      <v-col md="9" sm="6" cols="12" class="py-0 my-0">
        <p
          class="google-font mb-1"
          style="font-size:150%"
        ><b>Quellen</b></p>
        <a href="https://de.pngtree.com/so/anonym" target="_blank">anonym png von de.pngtree.com</a>
      </v-col><!--
      <v-col md="3" sm="6" cols="12" class="py-0 my-0">
        <img :src="require('@/assets/img/svg/contact.svg')" style="float:right" width="80%" alt />
      </v-col>
      -->
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
//https://stackoverflow.com/company/contact
export default {
    data:()=>({
    }),
    computed:{
      ...mapState(['config'])
    },
  props: ["data"],
};
</script>